import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_level_monitoring_run_hdr_RowClass } from '../../../dbschema/bl_inv_stock_level_monitoring_run_hdr.model';

export class StockLevelMonitoringRunHdrModel extends BaseContainerModel {
  bl_inv_stock_level_monitoring_run_hdr: bl_inv_stock_level_monitoring_run_hdr_RowClass = new bl_inv_stock_level_monitoring_run_hdr_RowClass();
}
